//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GoogleMaps from '../../components/general/GoogleMaps'

export default {
    metaInfo: {
        meta: [
            {charset: 'utf-8'},
            {
                name: 'viewport',
                content:
                    'width=device-width, initial-scale=1, user-scalable=no',
            },
        ],
    },
    data() {
        return {
            selectedCategory: null,
            categories: [
                'Todo',
                'Picadas',
                'Hamburguesas',
                'Papas Chips',
                'Antojos',
                'Extras',
            ],
            orderNo: '',
            name: '',
            specialComments: '',
            selectedItemIndex: 0,
            seamless: false,
            whatsappNumber: '67958328',
            selectedItem: {},
            paymentMethods: [
                {label: 'Yappy', value: 'Yappy'},
                {label: 'Efectivo', value: 'Efectivo'},
                {label: 'Tarjeta', value: 'Tarjeta'},
            ],
            pickupMethods: [
                {label: 'Delivery', value: 'Delivery'},
                {label: 'Retirar en local', value: 'Retirar en local'},
            ],
            selectedPickupMethod: '',
            premises: [
                {label: 'Arraijan', value: 'Arraijan'},
                {label: 'Chorrera', value: 'Chorrera'},
            ],
            selectedPremises: '',
            selectedPaymentMethod: null,
            address: '',
            total: 0,
            location: [],
            markers: [],
            center: {},
            defaultLat: 8.92773,
            defaultLng: -79.729467,
            optionsDialog: false,
            stylesDialog: false,
            sideDialog: false,
            successDialog: false,
            cartDialog: false,
            locationDialog: false,
            cart: [],
            menu: [
                {
                    title: 'Picada de chuletas fritas con acompañante y soda',
                    desc:
                        '2 Chuletas fritas acompañantes de papas fritas, papas wedgen o yuca frita y soda.',
                    type: 'mix',
                    pic: '',
                    price: 6.5,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Papas fritas',
                            price: 0,
                        },
                        {
                            title: 'Papas Wedgen',
                            price: 0,
                        },
                        {
                            title: 'Yuca frita',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Picada Cero Tranque',
                    desc:
                        '5 Wings, 5 deditos de pollo, 1 orden de papas ChoriChips y 2 sodas.',
                    type: 'mix',
                    pic: '',
                    price: 12.99,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Picada Mega Burger',
                    desc:
                        '2 Cero Tranque Burger con papas, 5 alitas, 5 deditos de pollo y 2 sodas.',
                    type: 'mix',
                    pic: '',
                    price: 17.99,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Cero Tranque Burger',
                    subtitle:
                        'Incluye papas fritas, yuca frita o papas wedgen.',
                    desc:
                        'Pan fresco, carne de res 8 onzas, bacon, lechuga, queso cheddar y salsa de la casa.',
                    type: 'burger',
                    pic: '',
                    price: 5.5,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Papas Fritas',
                            price: 0,
                        },
                        {
                            title: 'Yuca Frita',
                            price: 0.5,
                        },
                        {
                            title: 'Papas Wedgen',
                            price: 0.5,
                        },
                    ],
                },
                {
                    title: 'La Para-Trafico Burger',
                    subtitle:
                        'Incluye papas fritas, yuca frita o papas wedgen.',
                    desc:
                        'Pan fresco, carne de res 8 onzas, trocitos de cerdo frito, bacon, lechuga, queso cheddar y salsa de la casa. *Incluye papas fritas.',
                    type: 'burger',
                    pic: '',
                    price: 5.99,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Papas Fritas',
                            price: 0,
                        },
                        {
                            title: 'Yuca Frita',
                            price: 0.5,
                        },
                        {
                            title: 'Papas Wedgen',
                            price: 0.5,
                        },
                    ],
                },
                {
                    title: 'Colision y Fuga Burger',
                    subtitle:
                        'Incluye papas fritas, yuca frita o papas wedgen.',
                    desc:
                        'Pan fresco, carne de res 8 onzas, 1 chuleta, 2 tiras de pollo, lechuga, queso cheddar y salsa de la chasa. *Incluye papas fritas.',
                    type: 'burger',
                    pic: '',
                    price: 7.99,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Papas Fritas',
                            price: 0,
                        },
                        {
                            title: 'Yuca Frita',
                            price: 0.5,
                        },
                        {
                            title: 'Papas Wedgen',
                            price: 0.5,
                        },
                    ],
                },
                {
                    title: 'Doble Cheese Burger',
                    subtitle:
                        'Incluye papas fritas, yuca frita o papas wedgen.',
                    desc:
                        'Pan fresco, doble carne de 2 onzas, lechuga y doble queso. *Incluye papas fritas.',
                    type: 'burger',
                    pic: '',
                    price: 2.99,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Papas Fritas',
                            price: 0,
                        },
                        {
                            title: 'Yuca Frita',
                            price: 0.5,
                        },
                        {
                            title: 'Papas Wedgen',
                            price: 0.5,
                        },
                    ],
                },
                {
                    title: 'La Chicken Burger',
                    subtitle:
                        'Incluye papas fritas, yuca frita o papas wedgen.',
                    desc:
                        'Pan fresco, tiras de pollo apanado, pollo mechado, queso cheddar y salsa de la casa. *Incluye papas fritas.',
                    type: 'burger',
                    pic: '',
                    price: 5.5,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Papas Fritas',
                            price: 0,
                        },
                        {
                            title: 'Yuca Frita',
                            price: 0.5,
                        },
                        {
                            title: 'Papas Wedgen',
                            price: 0.5,
                        },
                    ],
                },
                {
                    title: 'Papas ChoriChips y Soda',
                    desc:
                        'Papas, queso mixto, chorizo ahumado y salsa de la casa.',
                    type: 'chips',
                    pic: '',
                    price: 5.99,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Papas Chicken Special y Soda',
                    desc:
                        'Papas fritas, pollo a la plancha, mix de queso y salsa de la casa.',
                    type: 'chips',
                    pic: '',
                    price: 5.99,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Papas BBQ Pork y Soda',
                    desc:
                        'Papas fritas, cerdo en salsa BBQ, mix de queso y salsa de ajo.',
                    type: 'chips',
                    pic: '',
                    price: 5.99,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Papas Cero Tranque Supreme y 2 Sodas',
                    desc:
                        'Papas fritas, pollo a la plancha, puerco, chorizo, queso mixto, salsa de la casa. (Ideal para 2 personas).',
                    type: 'chips',
                    pic: '',
                    price: 9.99,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Nachos Cero Tranque y Soda',
                    desc:
                        'Tortilla de maiz, carne, salsa de queso y pico de gallo fresco.',
                    type: 'whim',
                    pic: '',
                    price: 4.5,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Arepa de Carne y Pollo',
                    desc:
                        'Carne y pollo mechado, queso mixto, salsa de la casa.',
                    type: 'whim',
                    pic: '',
                    price: 3.5,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                        {
                            title: 'Combo - Papas Fritas y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Yuca Frita y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Papas Wedgen y soda',
                            price: 1.75,
                        },
                    ],
                },
                {
                    title: 'Hot Dog',
                    desc:
                        'Salchicha de carne, Salsa de piña, queso cheddar y salsas.',
                    type: 'whim',
                    pic: '',
                    price: 2,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                        {
                            title: 'Combo - Papas Fritas y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Yuca Frita y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Papas Wedgen y soda',
                            price: 1.75,
                        },
                    ],
                },
                {
                    title: 'Chili Dog',
                    desc: 'Salchicha de carne, queso chedar, y carne chili.',
                    type: 'whim',
                    pic: '',
                    price: 2.75,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                        {
                            title: 'Combo - Papas Fritas y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Yuca Frita y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Papas Wedgen y soda',
                            price: 1.75,
                        },
                    ],
                },
                {
                    title: 'Deditos de pollo (6 unidades)',
                    desc:
                        'Tiras de pollo apanadas en salsa BBQ, Honey Mustard o Picante.',
                    type: 'whim',
                    pic: '',
                    price: 3.5,
                    count: 0,
                    styles: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                        {
                            title: 'Combo - Papas Fritas y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Yuca Frita y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Papas Wedgen y soda',
                            price: 1.75,
                        },
                    ],
                    sides: [],
                    options: [
                        {
                            title: 'Salsa BBQ',
                            price: 0,
                        },
                        {
                            title: 'Honey Mustard',
                            price: 0,
                        },
                        {
                            title: 'Picante',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Wings (6 o 10 unidades)',
                    desc:
                        'Alitas apanadas en salsa BBQ, Honey Mustard o Picante.',
                    type: 'whim',
                    pic: '',
                    price: 0,
                    count: 0,
                    styles: [
                        {
                            title: 'Salsa BBQ',
                            price: 0,
                        },
                        {
                            title: 'Honey Mustard',
                            price: 0,
                        },
                        {
                            title: 'Picante',
                            price: 0,
                        },
                    ],
                    sides: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                        {
                            title: 'Combo - Papas Fritas y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Yuca Frita y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Papas Wedgen y soda',
                            price: 1.75,
                        },
                    ],
                    options: [
                        {
                            title: '6 unidades',
                            price: 3.5,
                        },
                        {
                            title: '10 unidades',
                            price: 5.99,
                        },
                    ],
                },
                {
                    title: 'Quesadilla (Pollo o Carne)',
                    desc:
                        'Tortilla de harina 3 unidades, carne o pollo, queso cheddar, pico de gallo fresco.',
                    type: 'whim',
                    pic: '',
                    price: 0,
                    count: 0,
                    styles: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                        {
                            title: 'Combo - Papas Fritas y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Yuca Frita y soda',
                            price: 1.5,
                        },
                        {
                            title: 'Combo - Papas Wedgen y soda',
                            price: 1.75,
                        },
                    ],
                    sides: [],
                    options: [
                        {
                            title: 'Pollo',
                            price: 2.99,
                        },
                        {
                            title: 'Carne',
                            price: 3.5,
                        },
                    ],
                },
                {
                    title: 'Adicionales',
                    desc:
                        'Agregue orden de papas fritas, papas wedgen o yuca frita.',
                    type: 'extra',
                    pic: '',
                    price: 0,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Orden de papas fritas',
                            price: 1.5,
                        },
                        {
                            title: 'Orden de papas wedgen',
                            price: 1.99,
                        },
                        {
                            title: 'Orden de yuca frita',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Bebidas',
                    desc:
                        'Elija entre soda, agua o alguno de nuestros deliciosos batidos.',
                    type: 'extra',
                    pic: '',
                    price: 0,
                    count: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Soda de lata',
                            price: 1.25,
                        },
                        {
                            title: 'Botella de agua',
                            price: 1,
                        },
                        {
                            title: 'Batido de fresa',
                            price: 2.5,
                        },
                        {
                            title: 'Batido de melocoton',
                            price: 2.5,
                        },
                        {
                            title: 'Batido de piña',
                            price: 2.5,
                        },
                        {
                            title: 'Batido de papaya',
                            price: 2.5,
                        },
                        {
                            title: 'Batido de guineo',
                            price: 2.5,
                        },
                    ],
                },
            ],
        }
    },
    methods: {
        filterMenu(menu) {
            let type = ''
            if (this.selectedCategory === 'Todo') {
                type = 'all'
                return this.menu
            }
            if (this.selectedCategory === null) {
                return this.menu
            }
            if (this.selectedCategory === 'Picadas') type = 'mix'
            if (this.selectedCategory === 'Hamburguesas') type = 'burger'
            if (this.selectedCategory === 'Papas Chips') type = 'chips'
            if (this.selectedCategory === 'Antojos') type = 'whim'
            if (this.selectedCategory === 'Extras') type = 'extra'
            return menu.filter(m => {
                if (m.type === type) return m
            })
        },
        addItemToCart() {
            if (!this.checkIfDuplicate()) {
                this.selectedItem.amount = 1
                this.cart.push(this.selectedItem)
                this.optionsDialog = false
                this.successDialog = true
                this.calculateTotal()
            } else {
                this.cart.forEach(c => {
                    if (
                        c.type === this.selectedItem.type &&
                        c.title === this.selectedItem.title &&
                        c.options.title === this.selectedItem.options.title &&
                        c.styles.title === this.selectedItem.styles.title &&
                        c.sides.title === this.selectedItem.sides.title
                    ) {
                        c.amount++
                    }
                })
                this.optionsDialog = false
                this.successDialog = true
                this.calculateTotal()
            }
        },
        handleDialogs(section, item) {
            //option, style, side
            if (section === 'option') {
                this.selectedItem.options = item
                this.optionsDialog = false
                if (this.menu[this.selectedItemIndex].styles.length > 0) {
                    this.stylesDialog = true
                } else {
                    this.addItemToCart()
                }
            }
            if (section === 'style') {
                this.selectedItem.styles = item
                this.stylesDialog = false
                if (this.menu[this.selectedItemIndex].sides.length > 0) {
                    this.sideDialog = true
                } else {
                    this.addItemToCart()
                }
            }
            if (section === 'side') {
                this.sideDialog = false
                this.selectedItem.sides = item
                this.addItemToCart()
            }
        },
        selectItem(item) {
            let itemInMenu = this.menu.filter((m, index) => {
                if (m.title === item.title) {
                    this.selectedItemIndex = index
                    return m
                }
            })
            this.selectedItem = JSON.parse(
                JSON.stringify(this.menu[this.selectedItemIndex])
            )
            this.optionsDialog = true
        },
        checkIfDuplicate() {
            let isDuplicate = false
            if (this.cart.length <= 0) {
                isDuplicate = false
            }

            this.cart.forEach(c => {
                if (
                    c.type === this.selectedItem.type &&
                    c.title === this.selectedItem.title &&
                    c.options.title === this.selectedItem.options.title &&
                    c.styles.title === this.selectedItem.styles.title
                ) {
                    isDuplicate = true
                }
            })

            return isDuplicate
        },
        removeItemFromCart(i) {
            this.cart.splice(i, 1)
        },
        calculateTotal() {
            let total = 0
            this.cart.forEach(c => {
                if (c.price) total += c.price * c.amount
                if (c.options.price) total += c.options.price * c.amount
                if (c.styles.price) total += c.styles.price * c.amount
                if (c.sides.price) total += c.sides.price * c.amount
            })
            this.total = total
        },
        generateMessage() {
            let message =
                'Buenas me gustaria realizar un pedido de:%0D%0A%0D%0A'
            for (let item of this.cart) {
                message += `- (${item.amount}) ${item.title} - ${item.options.title}`
                if (item.styles.title != undefined) {
                    message += `- ${item.styles.title}`
                }
                if (item.sides.title != undefined) {
                    message += `- ${item.sides.title}`
                }
                message += `%0D%0A`
            }
            message += `%0D%0ANo. de pedido: ${this.orderNo}%0D%0ANombre: ${this.name}`
            if (this.specialComments.length > 0)
                message += `%0D%0AComentarios especiales: ${this.specialComments}`
            if (this.selectedPickupMethod == 'Delivery') {
                message += `%0D%0AUbicacion: ${this.getLocationForMessage()}%0D%0ADireccion: ${
                    this.address
                }`
            }
            message += `%0D%0AMetodo de entrega: ${
                this.selectedPickupMethod
            }%0D%0AMetodo de pago: ${this.selectedPaymentMethod}%0D%0ALocal: ${
                this.selectedPremises
            }%0D%0ATotal: $ ${this.total.toFixed(2)}`
            message = message.replace(/\+/g, '%2B')
            message = message.replace(/&/g, '%26')
            message = message.replace(/#/g, '%23')
            return message
        },
        async sendToGoogleDriveSheet() {
            let message = ''
            for (let item of this.cart) {
                message += `- (${item.amount}) ${item.title} - ${item.options.title}`
                if (item.styles.title != undefined) {
                    message += `- ${item.styles.title}`
                }
                if (item.sides.title != undefined) {
                    message += `- ${item.sides.title}`
                }
                message += `\n`
            }
            let data = {
                id: this.orderNo,
                pedido: message,
                nombre: this.name,
                status: 'orden creada',
                total: this.total,
                local: this.selectedPremises,
                metodo_de_pago: this.selectedPaymentMethod,
                metodo_de_entrega: this.selectedPickupMethod,
            }
            if (data.metodo_de_entrega === 'Delivery') {
                data.direcion_1 = this.getLocationForMessage()
                data.direcion_2 = this.address
            }
            var url =
                'https://script.google.com/macros/s/AKfycbzPCB7GpZlqm0iKBy8mDPpa12_QFmcTukrsPlaINRFSYjWGvfD9/exec'
            var xhr = new XMLHttpRequest()
            xhr.open('POST', url)
            // xhr.withCredentials = true;
            xhr.setRequestHeader(
                'Content-Type',
                'application/x-www-form-urlencoded'
            )
            // url encode form data for sending as post data
            var encoded = Object.keys(data)
                .map(function (k) {
                    return (
                        encodeURIComponent(k) +
                        '=' +
                        encodeURIComponent(data[k])
                    )
                })
                .join('&')
            await xhr.send(encoded)
        },
        getLocationForMessage() {
            if (this.location.length === 0) {
                if (
                    parseFloat(this.center.lat) ===
                        parseFloat(this.defaultLat) &&
                    parseFloat(this.center.lng) === parseFloat(this.defaultLng)
                ) {
                    return `>> Pedir Ubicacion !!`
                } else {
                    if (this.center.lat < 0)
                        this.center.lng = `+${this.center.lng}` //Google Maps
                    if (this.center.lng < 0)
                        this.center.lng = `+${this.center.lng}` //Google Maps
                    return `https://www.google.com/maps?q=${this.center.lat},${this.center.lng}`
                    // return `https://waze.com/ul?ll=${this.center.lat},${this.center.lng}&z=10`
                }
            } else {
                let lat = parseFloat(this.location.lat)
                let lng = parseFloat(this.location.lng)
                if (lat === NaN || lng === NaN) return `>> Pedir Ubicacion !!`
                if (lat < 0) lat = `+${lat}` //Google Maps
                if (lng < 0) lng = `+${lng}` //Google Maps
                return `https://www.google.com/maps?q=${lat},${lng}`
                // return `https://waze.com/ul?ll=${lat},${lng}&z=10`
            }
        },
        setMarkerPosition(event) {
            this.location = event
        },
        geolocate() {
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.center = {
                        lat: parseFloat(position.coords.latitude),
                        lng: parseFloat(position.coords.longitude),
                    }
                    this.markers.push({position: this.center})
                },
                error => {
                    this.center = {
                        lat: parseFloat(this.defaultLat),
                        lng: parseFloat(this.defaultLng),
                    }
                    this.markers.push({position: this.center})
                }
            )
        },
        async sendChat() {
            if (this.name == '') {
                alert('Debes ingresar tu nombre para enviar el pedido.')
                return
            }
            if (this.selectedPremises == '') {
                alert('Debes el local de servicio.')
                return
            }
            if (this.selectedPickupMethod == '') {
                alert('Debes seleccionar un metodo de entrega.')
                return
            }
            if (this.address == '' && this.selectedPickupMethod == 'Delivery') {
                alert(
                    'Debes ingresar tu direccion completa para la entrega de tu pedido.'
                )
                return
            }
            if (this.selectedPaymentMethod == null) {
                alert('Debes seleccionar un metodo de pago.')
                return
            } else {
                this.orderNo = Math.floor(100000 + Math.random() * 900000)
                this.$analytics.logEvent('wp-cerotranque', {
                    content_action: 'Orden Completada',
                })
                await this.sendToGoogleDriveSheet()
                window.location.href = `https://wa.me/507${
                    this.whatsappNumber
                }?text=${this.generateMessage()}`
            }
        },
    },
    watch: {
        cart() {
            this.calculateTotal()
            if (this.cart.length > 0) {
                this.seamless = true
                this.$store.commit('SET_DISPLAYFOOTER', true)
            } else {
                this.seamless = false
                this.$store.commit('SET_DISPLAYFOOTER', false)
            }
        },
        // selectedPickupMethod() {
        //     if (this.selectedPickupMethod == 'Delivery')
        //         this.locationDialog = true
        // },
    },
    components: {
        GoogleMaps,
    },
    mounted() {
        if (this.$hj) {
            this.$hj('vpv', 'funnel-step-one')
        }
        this.$store.commit('SET_DISPLAYFOOTER', false)
        let path = this.$route.params.path
        this.$analytics.logEvent('wp-cerotranque', {
            path,
        })
        this.geolocate()
    },
}
